module.exports = __webpack_public_path__ + "/build/web/svg/ic-search-white-24-px-2.cebc7127f956f08f12a61f8ef65e540b.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/ic-search-white-24-px-2.svg
// module id = 223
// module chunks = 13